function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaviconnn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Confluence"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.58,6.78a.5.5,0,0,0,.83,0l2-3A.5.5,0,0,0,14,3H10a.5.5,0,0,0-.42.78Z",
    style: {
      fill: "#1878f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,13.4a.48.48,0,0,0-.39-.15.5.5,0,0,0-.37.2,13.74,13.74,0,0,0-1.22,1.89C2.63,16,0,17.33,0,19c0,.75.53,1.83,3.07,2.73h0A9.53,9.53,0,0,0,5.4,22h.11a.5.5,0,0,0,0-1l-2.19-.23c-1-.41-1.36-.8-1.36-1,0-.42,1.13-1.23,4.12-1.77A7.73,7.73,0,0,0,6,19.51a.5.5,0,0,0,.5.49h3a.5.5,0,0,0,.5-.5,5.86,5.86,0,0,1,1.17-3.17.5.5,0,0,0,0-.59C10.59,15.06,9.92,14.32,9,13.4Z",
    style: {
      fill: "#1878f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.94,15.34a16.35,16.35,0,0,0-2.22-3.12l.42-.43C18,8.85,21,5.8,21,2.5A.5.5,0,0,0,20.42,2l-3,.5a.5.5,0,0,0-.37.28,24.76,24.76,0,0,1-5,6.56A24.79,24.79,0,0,1,7,2.79a.5.5,0,0,0-.37-.28l-3-.5A.5.5,0,0,0,3,2.5c0,3.3,3,6.34,5.85,9.28C11.5,14.49,14,17,14,19.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.49A7.69,7.69,0,0,0,17.88,18c3,.54,4.12,1.35,4.12,1.77,0,.22-.36.62-1.36,1L18.45,21a.5.5,0,0,0,0,1h.11a9.53,9.53,0,0,0,2.3-.26h0c2.54-.91,3.07-2,3.07-2.73C24,17.33,21.37,16,16.94,15.34Z",
    style: {
      fill: "#1878f2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconnn);
export default __webpack_public_path__ + "static/media/faviconnn.964bf7138e6191466d53e75a2e8afd53.svg";
export { ForwardRef as ReactComponent };